import { graphql, useStaticQuery } from "gatsby"

const usePosts = () => {
  const { allMarkdownRemark, allMdx } = useStaticQuery(graphql`
    query BlogRollQuery {
      allMarkdownRemark(
        sort: { frontmatter: { date: DESC } }
        filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
      ) {
        edges {
          node {
            excerpt(pruneLength: 400)
            id
            fields {
              slug
            }
            frontmatter {
              title
              tags
              templateKey
              date(formatString: "YYYY-MM-DD")
              image {
                childImageSharp {
                  gatsbyImageData(quality: 100, width: 768, height: 576)
                }
              }
              previewImage {
                childImageSharp {
                  gatsbyImageData(quality: 100, width: 768, height: 576)
                }
              }
            }
          }
        }
      }
      allMdx(
        sort: { frontmatter: { date: DESC } }
        filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
      ) {
        edges {
          node {
            excerpt(pruneLength: 400)
            id
            fields {
              slug
            }
            frontmatter {
              title
              tags
              templateKey
              date(formatString: "YYYY-MM-DD")
              image {
                childImageSharp {
                  gatsbyImageData(quality: 100, width: 768, height: 576)
                }
              }
              previewImage {
                childImageSharp {
                  gatsbyImageData(quality: 100, width: 768, height: 576)
                }
              }
            }
          }
        }
      }
    }
  `)

  const posts = allMarkdownRemark.edges
    .concat(allMdx.edges)
    .map((e) => e.node)
    .sort((a, b) => -a.frontmatter.date.localeCompare(b.frontmatter.date))

  const tags = [
    ...new Set(posts.flatMap((post) => post.frontmatter.tags ?? [])),
  ]
  return { posts, tags }
}

export default usePosts
